import { z } from 'zod';

import {
  VenueDefaultDataAccommodation,
  VenueDefaultDataEquipment,
  VenueDefaultDataMobility,
} from '@/domain/project-venue/entities/project-venue.entity';

export const projectVenueDtoSchema = z.object({
  id: z.number(),
  organisationId: z.number(),
  name: z.string(),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
  image: z.string().nullable(),
  location: z.string(),
  venue: z.string().nullable(),
  properties: z
    .object({
      presetTitle: z.string().optional(),
      avgCapacity: z.number().optional(),
      accommodation: z.custom<VenueDefaultDataAccommodation>().optional(),
      equipment: z.custom<VenueDefaultDataEquipment>().optional(),
      mobility: z.custom<VenueDefaultDataMobility>().optional(),
    })
    .nullable(),
  models: z.object({
    structure: z.object({
      ess: z.string(),
      env: z.string(),
    }),
    events: z.object({
      ess: z.string(),
      env: z.string(),
    }),
  }),
});

export const getProjectsVenueDtoSchema = z.object({
  data: z.array(projectVenueDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export const getProjectVenueDtoSchema = projectVenueDtoSchema;

export type ProjectVenueDto = z.infer<typeof projectVenueDtoSchema>;
